<template>
  <div class="widget-contact-info-card" :class="config?.theme?.components?.contactInfoCard">
    <div v-if="title" class="widget-contact-info-card_title-wrapper">
      <WidgetIcon
        v-if="icon && !checkTheme('volvo', 'mercedes', 'cinch', 'crashdaddy', 'tesla', 'aa', 'suzuki', 'common')"
        :icon="icon"
        class="widget-primary-icon size-6"
      />
      <p
        class="widget-contact-info-card_title"
        :class="[
          {
            'border-b pb-4': !description && checkTheme('mini', 'bmw', 'toyota', 'default', 'volvo', 'crashdaddy'),
          },
          componentStyles?.title || '',
        ]"
      >
        {{ title }}
      </p>
    </div>
    <div v-else-if="checkTheme('mini', 'bmw', 'default')" class="border-b"></div>
    <p v-if="description" class="widget-contact-info-card_description">
      {{ description }}
    </p>
    <template v-if="phone && Array.isArray(phone)">
      <WButton
        v-for="item in phone"
        :key="item?.title"
        target="_blank"
        tag="a"
        tabindex="-1"
        class="widget-contact-info-card_phone"
        :href="isCopyToClipboard ? '' : `tel:${item?.number || phoneNumber}`"
        type="ghost"
        :class="[twMerge(itemVariants({ variant: getClientTheme() })), componentStyles?.button?.step || '']"
        @click="handleClick($event, item)"
      >
        <div class="flex items-center">
          <div v-if="checkTheme('landrover')" class="-ml-1 mr-2 flex items-center justify-center rounded-full">
            <WidgetIcon
              :icon="
                isCopyToClipboard
                  ? item?.copied
                    ? themeIcons.clipBoardCheck
                    : themeIcons.clipBoard
                  : themeIcons.chevronRight
              "
              class="widget-primary-icon size-6"
            />
          </div>
          <div
            v-if="
              checkTheme(
                ['volvo', StepType.ASSISTANCE],
                ['default', StepType.ASSISTANCE],
                'bmw',
                'toyota',
                'volkswagen',
                'bentley',
                'vwg',
                'audi',
                'tesla',
                'aa',
                'suzuki',
                'common',
                'cinch',
                'crashdaddy',
                'mercedes',
                'mini',
                'mopar',
                'jeep',
                'samsung'
              )
            "
            class="mr-4 mt-0.5 flex h-full items-center justify-center self-center rounded-full"
          >
            <WidgetIcon :icon="themeIcons.phone" class="widget-primary-icon size-6" />
          </div>
          <div>
            <h2
              class="widget-contact-info-card_phone--title"
              :class="[{ title3: checkTheme('bmw', 'toyota') }, componentStyles?.title || '']"
            >
              {{ item?.title || item?.description || '' }}
            </h2>
            <p class="widget-contact-info-card_phone--content">{{ item?.number || phoneNumber }}</p>
          </div>
        </div>
        <div v-if="!checkTheme('landrover', 'mercedes')" class="flex h-12 items-center justify-center rounded-full">
          <WidgetIcon
            :icon="
              isCopyToClipboard
                ? item?.copied
                  ? themeIcons.clipBoardCheck
                  : themeIcons.clipBoard
                : themeIcons.chevronRight
            "
            class="widget-primary-icon widget-contact-info-card_icon size-6"
          />
        </div>
      </WButton>
    </template>
    <WButton
      v-else-if="phone"
      target="_blank"
      tabindex="-1"
      tag="a"
      class="widget-contact-info-card_phone !flex-row"
      :href="isCopyToClipboard ? '' : `tel:${phoneNumber}`"
      type="ghost"
      :class="[twMerge(itemVariants({ variant: getClientTheme() })), componentStyles?.button?.step || '']"
      @click="handleClick($event, phoneItem)"
    >
      <div class="flex items-center">
        <div v-if="checkTheme('landrover')" class="-ml-1 mr-2 flex items-center justify-center rounded-full">
          <WidgetIcon
            :icon="
              isCopyToClipboard
                ? phoneItem?.copied
                  ? themeIcons.clipBoardCheck
                  : themeIcons.clipBoard
                : themeIcons.chevronRight
            "
            class="widget-primary-icon size-6"
          />
        </div>
        <div
          v-if="
            checkTheme(
              ['volvo', StepType.ASSISTANCE],
              ['default', StepType.ASSISTANCE],
              'bmw',
              'toyota',
              'volkswagen',
              'bentley',
              'vwg',
              'audi',
              'tesla',
              'aa',
              'suzuki',
              'common',
              'cinch',
              'crashdaddy',
              'mopar',
              'jeep',
              'mercedes',
              'samsung'
            )
          "
          class="mr-4 mt-0.5 flex h-full items-center justify-center self-center rounded-full"
        >
          <WidgetIcon :icon="themeIcons.phone" class="widget-primary-icon size-6" />
        </div>
        <div>
          <h2
            class="widget-contact-info-card_phone--title"
            :class="[{ title3: checkTheme('bmw', 'toyota') }, componentStyles?.title || '']"
          >
            {{ phone?.title || phone?.description || '' }}
          </h2>
          <p class="widget-contact-info-card_phone--content">{{ phoneNumber }}</p>
        </div>
      </div>
      <div v-if="!checkTheme('landrover', 'mercedes')" class="flex h-12 items-center justify-center rounded-full">
        <WidgetIcon
          :icon="
            isCopyToClipboard
              ? phoneItem?.copied
                ? themeIcons.clipBoardCheck
                : themeIcons.clipBoard
              : themeIcons.chevronRight
          "
          class="widget-primary-icon widget-contact-info-card_icon size-6"
        />
      </div>
    </WButton>
    <template v-if="mail && Array.isArray(mail)">
      <WButton
        v-for="item in mail"
        :key="item?.title"
        target="_blank"
        tabindex="-1"
        tag="a"
        class="widget-contact-info-card_mail"
        :href="isCopyToClipboard ? '' : `mailto:${item?.address || email}`"
        type="ghost"
        :class="[twMerge(itemVariants({ variant: getClientTheme() })), componentStyles?.button?.step || '']"
        @click="handleClick($event, item)"
      >
        <div class="flex items-center">
          <div v-if="checkTheme('landrover')" class="-ml-1 mr-2 flex items-center justify-center rounded-full">
            <WidgetIcon
              :icon="
                isCopyToClipboard
                  ? item?.copied
                    ? themeIcons.clipBoardCheck
                    : themeIcons.clipBoard
                  : themeIcons.chevronRight
              "
              class="widget-primary-icon size-6"
            />
          </div>
          <div
            v-if="
              checkTheme(
                'mercedes',
                'mini',
                'tesla',
                'aa',
                'suzuki',
                'common',
                'cinch',
                'crashdaddy',
                'bmw',
                'toyota',
                'samsung',
                'mopar',
                'jeep',
                'bentley'
              )
            "
            class="mr-4 mt-0.5 flex h-full items-center justify-center self-center rounded-full"
          >
            <WidgetIcon :icon="themeIcons.mail" class="widget-primary-icon size-6" />
          </div>
          <div>
            <h2
              class="widget-contact-info-card_mail--title"
              :class="[{ title3: checkTheme('bmw', 'toyota') }, componentStyles?.title || '']"
            >
              {{ item?.title || item?.description || '' }}
            </h2>
            <p class="widget-contact-info-card_mail--content">{{ item?.address || email }}</p>
          </div>
        </div>
        <div v-if="!checkTheme('landrover', 'mercedes')" class="flex h-12 items-center justify-center rounded-full">
          <WidgetIcon
            :icon="
              isCopyToClipboard
                ? item?.copied
                  ? themeIcons.clipBoardCheck
                  : themeIcons.clipBoard
                : themeIcons.chevronRight
            "
            class="widget-primary-icon widget-contact-info-card_icon size-6"
          />
        </div>
      </WButton>
    </template>
    <WButton
      v-else-if="mail"
      target="_blank"
      tabindex="-1"
      tag="a"
      class="widget-contact-info-card_mail"
      :href="isCopyToClipboard ? '' : `mailto:${email}`"
      @click="handleClick($event, mailItem)"
      type="ghost"
      :class="[twMerge(itemVariants({ variant: getClientTheme() })), componentStyles?.button?.step || '']"
    >
      <div class="flex items-center">
        <div v-if="checkTheme('landrover')" class="-ml-1 mr-2 flex items-center justify-center rounded-full">
          <WidgetIcon
            :icon="
              isCopyToClipboard
                ? mailItem?.copied
                  ? themeIcons.clipBoardCheck
                  : themeIcons.clipBoard
                : themeIcons.chevronRight
            "
            class="widget-primary-icon size-6"
          />
        </div>
        <div
          v-if="
            checkTheme(
              'mercedes',
              'mini',
              'bmw',
              'toyota',
              'samsung',
              'jeep',
              'mopar',
              'bentley',
              'cinch',
              'crashdaddy',
              'tesla',
              'aa',
              'suzuki',
              'common'
            )
          "
          class="mr-4 mt-0.5 flex h-full items-center justify-center self-center rounded-full"
        >
          <WidgetIcon :icon="themeIcons.mail" class="widget-primary-icon size-6" />
        </div>
        <div>
          <h2
            class="widget-contact-info-card_mail--title"
            :class="[{ title3: checkTheme('bmw', 'toyota') }, componentStyles?.title || '']"
          >
            {{ mail?.title || mail?.description || '' }}
          </h2>
          <p class="widget-contact-info-card_mail--content">{{ email }}</p>
        </div>
      </div>
      <div v-if="!checkTheme('landrover', 'mercedes')" class="flex h-12 items-center justify-center rounded-full">
        <WidgetIcon
          :icon="
            isCopyToClipboard
              ? mailItem?.copied
                ? themeIcons.clipBoardCheck
                : themeIcons.clipBoard
              : themeIcons.chevronRight
          "
          class="widget-primary-icon widget-contact-info-card_icon size-6"
        />
      </div>
    </WButton>
  </div>
</template>

<script lang="ts" setup>
  import { computed, ref, watch } from 'vue';

  import { cva } from 'class-variance-authority';
  import { twMerge } from 'tailwind-merge';

  import { themeIcons, checkTheme, config, getClientTheme, getComponentStyle } from 'src/utils/config';

  import WButton from 'src/components/base/Button.vue';
  import WidgetIcon from 'src/components/base/WidgetIcon.vue';
  import { StepType } from 'src/types/widget';

  type PhoneConfig = { title?: string; number?: string; copied?: boolean; description?: string };
  type MailConfig = { title?: string; address?: string; copied?: boolean; description?: string };

  interface Props {
    title?: string;
    description?: string;
    icon?: string;
    phone?: PhoneConfig | PhoneConfig[];
    mail?: MailConfig | MailConfig[];
  }

  const isCopyToClipboard = computed(() => config.value.settings?.type === StepType.REFERRAL);
  const componentStyles = computed(() => getComponentStyle());
  const props = defineProps<Props>();
  const itemVariants = cva('p-4 rounded-custom w-full justify-between', {
    variants: {
      variant: {
        default: '',
        audi: '',
        samsung: 'p-4 !rounded-[0.8rem] border-0 shadow-[1px_1px_20px_2px_rgba(147,152,159,0.2)]',
        volkswagen: 'px-4 py-4 border border-backgroundSoft',
        bentley: 'px-4 py-4 border border-backgroundSoft',
        vwg: 'px-4 py-4 border border-backgroundSoft',
        mercedes: '',
        bmw: '',
        toyota: '',
        mopar: '',
        jeep: '',
        mini: '',
        jaguar: '',
        jlr: '',
        common: '',
        referral: '',
        landrover: 'justify-start',
        volvo: 'py-3 px-4',
        tesla: 'py-3 px-4',
        aa: 'px-4 py-4 border border-backgroundSoft',
        suzuki: 'py-3 px-4',
        cinch: 'py-3 px-4',
        crashdaddy: 'py-3 px-4',
      },
    },
    defaultVariants: {
      variant: getClientTheme(),
    },
  });

  const email = computed(
    () => (Array.isArray(props.mail) ? props.mail[0]?.address : props.mail?.address) || contactMail.value
  );
  const phoneNumber = computed(
    () => (Array.isArray(props.phone) ? props.phone[0]?.number : props.phone?.number) || contactPhone.value
  );

  const contactPhone = computed(() => {
    const phoneObj = config.value.settings?.contactInformation?.default?.find(
      (item) => 'phone' in item || 'number' in item
    ) as {
      phone?: string | undefined;
      number?: string | undefined;
      description?: string | undefined;
      title?: string | undefined;
    };
    return phoneObj?.phone || phoneObj?.number || config.value?.contact?.phone || '';
  });
  const contactMail = computed(() => {
    const mailObj = config.value.settings?.contactInformation?.default?.find(
      (item) => 'mail' in item || 'address' in item
    ) as {
      mail?: string | undefined;
      address?: string | undefined;
      description?: string | undefined;
      title?: string | undefined;
    };
    return mailObj?.mail || mailObj?.address || config.value?.contact?.email || '';
  });

  const phoneItem = ref<PhoneConfig>({ number: phoneNumber.value, title: '' });
  const mailItem = ref<MailConfig>({ address: email.value, title: '' });
  watch([phoneNumber, email], () => {
    phoneItem.value = { number: phoneNumber.value, title: '' };
    mailItem.value = { address: email.value, title: '' };
  });
  function handleClick(event: Event, item: Partial<MailConfig> | Partial<PhoneConfig> | undefined) {
    event.preventDefault();
    if (isCopyToClipboard.value && item) {
      item.copied = true;
      setTimeout(() => {
        item.copied = false;
      }, 1000);
      return navigator.clipboard.writeText(
        ('address' in item ? item?.address : 'number' in item ? item?.number : '') || ''
      );
    }
    if (item && 'address' in item) {
      return window.open(`mailto:${item?.address || email.value}`, '_blank');
    }
    if (item && 'number' in item) {
      return window.open(`tel:${item?.number || phoneNumber.value}`, '_blank');
    }
    return;
  }
</script>
